import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const Plus: BleskIcon = forwardRef(function Plus(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <path
        d="M5 12H19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 19V5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
